import {ModuleComponent} from "../../js/module-component";
import {GvfService} from "../../../gvf/js/gvf-service";
import {UtilsService} from "../../js/utils-service";

export class ModContact extends ModuleComponent{
    ready(){
        super.ready();
        this.$form = this.$root.find(".js-dynamic-form").first();
        this.findMember("send-form").click(()=>this.sendForm());
    }

    sendForm(){
        if(!this.$form.length){ return; }
        let $button = this.findMember("send-form");
        this.$form.checkRestrictions().then(
            (isOk)=>{
                if(!isOk){ return; }
                if(window.gtag && window.dataLayer){
                    window.gtag('consent', "update", {ad_storage: 'granted',ad_user_data: 'granted'});
                    window.dataLayer.push({'event': 'consent_updated'});
                }
                $button.prop("disabled",true);
                GvfService.endpoint("/web/dynamic-form/send-form",
                    {formData: this.$form.getValues()}).then(
                    (resp)=>{
                        UtilsService.alertEndpointResponse(resp, ()=>{
                            window.location.reload();
                        });
                    }
                ).catch(
                    (resp)=>{
                        UtilsService.alertEndpointResponse(resp);
                    }).finally(
                    ()=>{
                        $button.prop("disabled",false);
                    }
                );
            }
        );
    }
}
